// FlyingPhrases.jsx
import React from 'react';
import styles from './FlyingPhrases.module.css';

export default function FlyingPhrases({ amount }) {
  if (amount === null) return null;

  return <div className={styles.phrasesFly}>+{amount}</div>;
}
